"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("@xstyled/styled-components"));
var system_1 = require("@xstyled/system");
var ListItem_1 = __importDefault(require("./ListItem"));
var ListDivider_1 = __importDefault(require("./ListDivider"));
var List = Object.assign(styled_components_1.default.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: bg;\n    padding: 5 20 6;\n    border: none;\n\n    margin: 0;\n    padding: 2;\n    list-style: none;\n\n    box-shadow: inset 1px 1px 0px 1px ", ",\n      inset 0 0 0 1px ", ",\n      1px 1px 0 1px ", ";\n\n    ", ";\n  "], ["\n    background-color: bg;\n    padding: 5 20 6;\n    border: none;\n\n    margin: 0;\n    padding: 2;\n    list-style: none;\n\n    box-shadow: inset 1px 1px 0px 1px ", ",\n      inset 0 0 0 1px ", ",\n      1px 1px 0 1px ", ";\n\n    ",
    ";\n  "])), system_1.th('colors.white'), system_1.th('colors.grays.3'), system_1.th('colors.black'), function (_a) {
    var width = _a.width;
    return "\n  width: " + width + "px;\n";
}), {
    Item: ListItem_1.default,
    Divider: ListDivider_1.default,
});
List.displayName = 'List';
List.defaultProps = {
    width: 200,
};
exports.default = List;
var templateObject_1;
//# sourceMappingURL=List.js.map